import React from 'react'
import { AiFillGithub } from 'react-icons/ai'
import { FaLinkedinIn, FaInstagram } from 'react-icons/fa'

function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="footer-new">
      <div className="footer-inner">
        <div className="footer-brand">amaan<span>.dev</span></div>
        <div className="footer-copy">© {year} Amaan Akbany — Designed &amp; Built by me</div>
        <div className="footer-social">
          <a href="https://github.com/Amaan-AeonX" target="_blank" rel="noopener noreferrer"><AiFillGithub /></a>
          <a href="https://www.linkedin.com/in/amaan-akbany5/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
          <a href="https://www.instagram.com/maverick_520/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
